import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    errorContainer: {
        display: "flex",
        alignItems: "flex-start",
        gap: theme.spacing(1),
    },
    cardError: {
        marginTop: theme.spacing(1),
    },
    warningIcon: {
        width: 14,
        height: 14,
        color: theme.palette.error.main,
        flexShrink: 0,
        marginTop: theme.spacing(0.25),
    },
}));
